import React from 'react';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import styled from 'styled-components';

import SiteMetadata from '../components/SiteMetadata';
import TMarkUp from '../components/TMarkUp';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 2rem;
`;

const Heading = styled.h2`
  line-height: 2;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Paragraph = styled.p`
  line-height: 2;
  font-size: 1.25rem;
  max-width: 600px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 2rem;
`;

const MarketUnavailablePage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <SiteMetadata pageTitle={t('app.htmlTitle')} />
      <Container>
        <Heading>
          <TMarkUp value={t('error.title-market-unavailable')} />
        </Heading>
        <Paragraph>
          <TMarkUp value={t('error.description-market-unavailable')} />
        </Paragraph>
      </Container>
    </>
  );
};

export default MarketUnavailablePage;
